import { Link } from 'react-router-dom';

export default function InvestorRelationsPage() {
  const performance = [
    { year: '2021', return: '14.2%', aum: '€1.2B' },
    { year: '2022', return: '11.8%', aum: '€1.5B' },
    { year: '2023', return: '13.5%', aum: '€1.8B' },
    { year: '2024', return: '12.1%', aum: '€2.1B' },
    { year: '2025', return: '12.8%', aum: '€2.4B' },
  ];

  const cryptoStats = [
    { value: '€180M', label: 'Deployed in Crypto & Digital Assets' },
    { value: '12', label: 'Portfolio Companies & Protocols' },
    { value: '20.3%', label: 'Average Annual Return' },
    { value: '2020', label: 'Crypto-Friendly Since' },
  ];

  return (
    <main>
      {/* Hero */}
      <section className="relative pt-32 pb-16 md:pt-40 md:pb-20 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Premium%20modern%20Swiss%20financial%20district%20at%20golden%20hour%2C%20Zurich%20skyline%20with%20contemporary%20glass%20office%20buildings%2C%20warm%20sunlight%20reflecting%20on%20architectural%20facades%2C%20professional%20corporate%20atmosphere%2C%20clean%20minimalist%20aesthetic%2C%20bright%20sky%20with%20soft%20clouds%2C%20high%20end%20architectural%20photography%2C%20luxurious%20yet%20understated%20Swiss%20elegance&width=1920&height=700&seq=investor-hero-2026-v2&orientation=landscape"
            alt="CASA CHERE LIMITED – Investor Relations"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-background-50" />
        </div>
        <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="max-w-3xl">
            <span className="text-[10px] uppercase tracking-[3px] text-primary-300 font-semibold">
              Partner With Us
            </span>
            <h1 className="text-5xl md:text-7xl font-heading font-bold text-white mt-4 mb-6 tracking-tight">
              Investor Relations
            </h1>
            <p className="text-lg text-white/80 leading-relaxed max-w-2xl">
              Access our diversified portfolio of institutional-grade investments. We offer flexible structures tailored to the needs of institutional investors, family offices, and accredited professionals across all five sectors — including crypto and digital assets.
            </p>
          </div>
        </div>
      </section>

      {/* Two Investment Paths */}
      <section className="relative py-16 md:py-24 bg-white">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {/* Institutional */}
            <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-foreground-100/20 hover:border-primary-300/30 transition-all duration-300">
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-6">
                <i className="ri-bank-line text-2xl text-primary-600" />
              </div>
              <h3 className="text-xl font-heading font-bold text-foreground-950 mb-3">
                Institutional Investors
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed mb-6">
                Custom fund structures, segregated mandates, and co-investment vehicles for pension funds, insurance companies, sovereign wealth funds, and endowments.
              </p>
              <ul className="flex flex-col gap-3 mb-8">
                {[
                  'Minimum: €500,000',
                  'Custom mandate design',
                  'Quarterly reporting with full transparency',
                  'Dedicated relationship manager',
                  'Access to all five investment sectors',
                  'Co-investment priority rights',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-2.5">
                    <i className="ri-checkbox-circle-fill text-primary-500 text-sm mt-0.5 shrink-0" />
                    <span className="text-foreground-600 text-sm">{item}</span>
                  </li>
                ))}
              </ul>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white text-sm uppercase tracking-[2px] font-semibold px-6 py-3 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Inquire Now
                <i className="ri-arrow-right-line" />
              </Link>
            </div>

            {/* Professional */}
            <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-foreground-100/20 hover:border-accent-300/30 transition-all duration-300">
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-6">
                <i className="ri-user-star-line text-2xl text-accent-600" />
              </div>
              <h3 className="text-xl font-heading font-bold text-foreground-950 mb-3">
                Professional Investors
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed mb-6">
                Select investment vehicles for accredited individuals, family offices, and professional investors seeking diversified exposure with UK-grade governance.
              </p>
              <ul className="flex flex-col gap-3 mb-8">
                {[
                  'Minimum: €100,000',
                  'Semi-annual investor updates',
                  'Digital investor portal access',
                  'Annual general meeting invitation',
                  'Select sector exposure available',
                  'UK regulatory protections',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-2.5">
                    <i className="ri-checkbox-circle-fill text-accent-500 text-sm mt-0.5 shrink-0" />
                    <span className="text-foreground-600 text-sm">{item}</span>
                  </li>
                ))}
              </ul>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-white text-sm uppercase tracking-[2px] font-semibold px-6 py-3 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Request Investor Kit
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Statistics Dashboard */}
      <section className="relative py-20 md:py-28 bg-background-50">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="text-center mb-14">
            <span className="text-[10px] uppercase tracking-[3px] text-primary-500 font-semibold">
              By the Numbers
            </span>
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground-950 mt-4 mb-5 tracking-tight">
              Key Statistics
            </h2>
            <p className="text-foreground-500 text-base max-w-xl mx-auto">
              Nineteen years of disciplined capital deployment across five sectors, delivering consistent risk-adjusted returns for our partners.
            </p>
          </div>

          {/* Big Stat Cards */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mb-14">
            {[
              { value: '€2.4B+', label: 'Assets Under Management', icon: 'ri-funds-line' },
              { value: '12.8%', label: 'Avg Annual Return (5Y)', icon: 'ri-line-chart-line' },
              { value: '47', label: 'Active Investments', icon: 'ri-stack-line' },
              { value: '18', label: 'Countries Worldwide', icon: 'ri-global-line' },
            ].map((stat) => (
              <div key={stat.label} className="bg-white rounded-2xl p-6 md:p-8 border border-foreground-100/20 text-center hover:border-primary-200/40 transition-all duration-300">
                <div className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-4">
                  <i className={`${stat.icon} text-xl text-primary-600`} />
                </div>
                <p className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-1.5">
                  {stat.value}
                </p>
                <p className="text-foreground-400 text-xs uppercase tracking-[1.5px] font-medium">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>

          {/* Performance Table */}
          <div className="max-w-3xl mx-auto bg-white rounded-2xl border border-foreground-100/20 overflow-hidden mb-14">
            <div className="px-6 py-5 border-b border-foreground-100/20">
              <h3 className="text-sm font-heading font-bold text-foreground-950">Historical Performance</h3>
              <p className="text-foreground-400 text-xs mt-1">Annualized returns since strategic diversification — 2021</p>
            </div>
            <table className="w-full">
              <thead>
                <tr className="border-b border-foreground-100/30 bg-background-50/50">
                  <th className="text-left px-6 py-3.5 text-[10px] uppercase tracking-[2px] text-foreground-400 font-semibold">Year</th>
                  <th className="text-right px-6 py-3.5 text-[10px] uppercase tracking-[2px] text-foreground-400 font-semibold">Annual Return</th>
                  <th className="text-right px-6 py-3.5 text-[10px] uppercase tracking-[2px] text-foreground-400 font-semibold">AUM</th>
                  <th className="text-right px-6 py-3.5 text-[10px] uppercase tracking-[2px] text-foreground-400 font-semibold">MSCI World</th>
                </tr>
              </thead>
              <tbody>
                {performance.map((row, i) => (
                  <tr key={row.year} className={`${i < performance.length - 1 ? 'border-b border-foreground-100/20' : ''} hover:bg-background-50 transition-colors`}>
                    <td className="px-6 py-4 text-sm font-heading font-bold text-foreground-950">{row.year}</td>
                    <td className="px-6 py-4 text-sm font-heading font-bold text-accent-600 text-right">+{row.return}</td>
                    <td className="px-6 py-4 text-sm text-foreground-700 text-right">{row.aum}</td>
                    <td className="px-6 py-4 text-sm text-foreground-400 text-right">
                      {row.year === '2021' ? '+10.2%' : row.year === '2022' ? '+9.4%' : row.year === '2023' ? '+11.1%' : row.year === '2024' ? '+10.6%' : '+11.0%'}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="border-t-2 border-foreground-200/30 bg-background-50/80">
                  <td className="px-6 py-3.5 text-sm font-heading font-bold text-foreground-950">5Y Avg</td>
                  <td className="px-6 py-3.5 text-sm font-heading font-bold text-accent-600 text-right">+12.8%</td>
                  <td className="px-6 py-3.5 text-sm text-foreground-700 text-right">—</td>
                  <td className="px-6 py-3.5 text-sm text-foreground-400 text-right">+10.5%</td>
                </tr>
              </tfoot>
            </table>
          </div>

          <p className="text-center text-foreground-300 text-xs italic max-w-lg mx-auto">
            Performance figures are net of fees and represent blended portfolio returns. Past performance does not guarantee future results. For professional and accredited investors only.
          </p>
        </div>
      </section>

      {/* Sector Allocation */}
      <section className="relative py-20 md:py-28 bg-white">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-14">
              <span className="text-[10px] uppercase tracking-[3px] text-primary-500 font-semibold">
                Portfolio Composition
              </span>
              <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground-950 mt-4 mb-5 tracking-tight">
                Sector Allocation
              </h2>
              <p className="text-foreground-500 text-base max-w-xl mx-auto">
                Diversification across five uncorrelated sectors to optimize risk-adjusted returns.
              </p>
            </div>

            <div className="flex flex-col gap-4">
              {[
                { sector: 'Real Estate', pct: 35, color: 'bg-primary-500' },
                { sector: 'Renewable Energy', pct: 22, color: 'bg-accent-500' },
                { sector: 'Oil & Gas', pct: 18, color: 'bg-secondary-500' },
                { sector: 'Medical Equipment', pct: 15, color: 'bg-primary-400' },
                { sector: 'Crypto & Digital Assets', pct: 10, color: 'bg-accent-400' },
              ].map((item) => (
                <div key={item.sector} className="flex items-center gap-4">
                  <span className="text-sm text-foreground-700 font-medium w-48 shrink-0">{item.sector}</span>
                  <div className="flex-1 bg-background-100 rounded-full h-3 overflow-hidden">
                    <div
                      className={`${item.color} h-full rounded-full transition-all duration-1000`}
                      style={{ width: `${item.pct}%` }}
                    />
                  </div>
                  <span className="text-sm font-heading font-bold text-foreground-950 w-12 text-right">{item.pct}%</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Crypto & Digital Assets — Dedicated Section */}
      <section className="relative py-20 md:py-28 bg-background-50">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-14">
              <div className="inline-flex items-center gap-2 bg-accent-100 text-accent-700 text-xs uppercase tracking-[2px] font-semibold px-4 py-1.5 rounded-full mb-5">
                <i className="ri-bit-coin-line" />
                Crypto Friendly
              </div>
              <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground-950 mt-3 mb-5 tracking-tight">
                Crypto &amp; Digital Assets
              </h2>
              <p className="text-foreground-500 text-base max-w-2xl mx-auto">
                As one of the first UK institutions to embrace digital assets, we provide regulated, risk-managed exposure to the blockchain ecosystem — from infrastructure to DeFi to early-stage Web3 ventures.
              </p>
            </div>

            {/* Crypto Stat Cards */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mb-12">
              {cryptoStats.map((stat) => (
                <div key={stat.label} className="bg-white rounded-2xl p-6 border border-foreground-100/20 text-center hover:border-accent-300/40 transition-all duration-300">
                  <p className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-1.5">{stat.value}</p>
                  <p className="text-foreground-400 text-xs leading-relaxed">{stat.label}</p>
                </div>
              ))}
            </div>

            {/* Crypto Details Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-white rounded-2xl p-7 border border-foreground-100/20">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-4">
                  <i className="ri-server-line text-lg text-accent-600" />
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2">Blockchain Infrastructure</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  Institutional-grade validator nodes, staking services, and enterprise Web3 tooling operating from Crypto Valley in Zug, Switzerland. Our infrastructure investments provide stable, yield-generating exposure to the foundational layer of the digital asset economy.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-7 border border-foreground-100/20">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-4">
                  <i className="ri-swap-line text-lg text-accent-600" />
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2">DeFi &amp; Liquidity Protocols</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  Strategic investments in decentralized finance protocols providing institutional liquidity infrastructure. Our Dubai-based DeFi venture serves market makers and trading desks across major blockchain networks with enterprise-grade security and compliance.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-7 border border-foreground-100/20">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-4">
                  <i className="ri-shield-check-line text-lg text-accent-600" />
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2">UK-Regulated Custody</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  All digital assets under management are secured through UK-regulated custody solutions with institutional-grade cold storage, multi-signature authorization, and comprehensive insurance coverage — the same standards applied to traditional assets.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-7 border border-foreground-100/20">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-4">
                  <i className="ri-rocket-line text-lg text-accent-600" />
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2">Early-Stage Web3 Ventures</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  Selective allocations to early-stage Web3 companies building the next generation of decentralized infrastructure, identity solutions, and tokenized real-world assets. Our 2020 entry provides first-mover advantage in sourcing and due diligence.
                </p>
              </div>
            </div>

            {/* Crypto Approach Summary */}
            <div className="bg-white rounded-2xl p-8 border border-foreground-100/20 text-center">
              <h3 className="text-lg font-heading font-bold text-foreground-950 mb-3">Our Approach to Digital Assets</h3>
              <p className="text-foreground-500 text-sm leading-relaxed max-w-2xl mx-auto mb-5">
                We do not speculate. Every crypto investment is underwritten with the same institutional rigor as our real estate and energy assets — thorough due diligence, risk assessment, and ongoing monitoring. We invest in the infrastructure and protocols that enable the digital economy, not in short-term price movements. This disciplined approach has delivered a <strong className="text-foreground-900">20.3% average annual return</strong> across our crypto portfolio while maintaining institutional-grade risk controls.
              </p>
              <Link
                to="/portfolio"
                className="inline-flex items-center gap-2 text-accent-600 hover:text-accent-700 text-sm uppercase tracking-[2px] font-semibold transition-colors cursor-pointer"
              >
                View Crypto Portfolio
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="relative py-16 md:py-20 bg-white">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 text-center">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4 tracking-tight">
            Ready to Invest?
          </h2>
          <p className="text-foreground-500 text-base max-w-lg mx-auto mb-8">
            Our investor relations team is available to discuss your objectives and structure the right investment solution — including crypto and digital asset exposure.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              className="bg-primary-500 hover:bg-primary-600 text-white text-sm uppercase tracking-[2px] font-semibold px-8 py-4 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Schedule a Call
            </Link>
            <Link
              to="/portfolio"
              className="border-2 border-foreground-200 hover:border-primary-400 text-foreground-700 hover:text-primary-600 text-sm uppercase tracking-[2px] font-semibold px-8 py-4 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              View Portfolio
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}